import type { ToolEventGroup } from "../state/chat";

interface ToolEventCardProps {
  group: ToolEventGroup;
}

export function ToolEventCard({ group }: ToolEventCardProps) {
  return (
    <details className={`tool-card ${group.status}`} open={group.status === "running"}>
      <summary>
        <span className="tool-dot" />
        <span>{group.status === "running" ? "正在调用" : "工具调用"}</span>
        <strong>{group.title}</strong>
      </summary>
      <pre>{JSON.stringify(group.events[group.events.length - 1] ?? {}, null, 2)}</pre>
    </details>
  );
}
